export const businessServices = [
    {
        type: "Restaurant",
        subtype: "Food Service Establishment",
        icon: "svg/Restaurant-icon.svg",
        services: [
            "Dine-in Service",
            "Takeaway Orders",
            "Home Delivery",
            "Event Catering",
            "Online Ordering",
            "Buffet Services",
            "Outdoor Catering",
            "Corporate Catering",
            "Food Truck Service",
            "Other",
        ],
    },
    {
        type: "Real Estate Broker",
        subtype: "Property Transaction Facilitator",
        icon: "svg/Estate-icon.svg",
        services: [
            "Property Sales",
            "Property Rentals",
            "Property Viewings",
            "Price Valuation",
            "Legal Help",
            "Property Marketing",
            "Virtual Property Tours",
            "Mortgage Assistance",
            "Property Documentation Services",
            "Other",
        ],
    },
    {
        type: "Salon",
        subtype: "Hair Styling & Grooming",
        icon: "svg/Saloon-icon.svg",
        services: [
            "Haircuts",
            "Hair Spa Treatments",
            "Hair Straightening",
            "Nail Extensions",
            "Facials",
            "Bridal Packages",
            "Spa Treatments",
            "Hair Coloring & Highlights",
            "Skin Treatments",
            "Other",
        ],
    },
    {
        type: "Doctor's Clinic",
        subtype: "Medical Consultation & Treatment",
        icon: "svg/Doctor-clinic-icon.svg",
        services: [
            "General Checkups",
            "Specialist Consultations",
            "Vaccinations",
            "Blood Tests",
            "Health Screenings",
            "Telemedicine Consultations",
            "Emergency Care",
            "Chronic Disease Management",
            "Physiotherapy",
            "Other",
        ],
    },
    {
        type: "Dry Cleaner",
        subtype: "Garment Cleaning & Care",
        icon: "svg/Dry -Cleaner-icon.svg",
        services: [
            "Garment Cleaning",
            "Stain Removal",
            "Clothing Alterations",
            "Leather & Suede Cleaning",
            "Shoe Cleaning & Polishing",
            "Curtain & Drapery Cleaning",
            "Eco-Friendly Cleaning Services",
            "Same-Day Service",
            "Other",
        ],
    },
    {
        type: "Web Design Agency",
        subtype: "Website Creation & Development",
        icon: "svg/Web-Design-Agency-icon.svg",
        services: [
            "Website Creation",
            "Responsive Design",
            "SEO Services",
            "Website Maintenance",
            "E-commerce Setup",
            "Mobile App Development",
            "UX/UI Design",
            "Domain & Hosting Services",
            "Website Security Audits",
            "Other",
        ],
    },
    {
        type: "Gym & Fitness Center",
        subtype: "Exercise Facility & Training",
        icon: "svg/Gym-icon.svg",
        services: [
            "Group Fitness Classes",
            "Weight Training Equipment",
            "Cardio Workouts",
            "Personal Training Sessions",
            "Diet & Nutrition Counseling",
            "Yoga Classes",
            "Zumba Sessions",
            "CrossFit Training",
            "Other",
        ],
    },
    {
        type: "Marketing Agency",
        subtype: "Business Promotion Strategies",
        icon: "svg/Marketing Agency.svg",
        services: [
            "Social Media Advertising",
            "Content Creation",
            "Email Marketing",
            "PPC Ads",
            "Branding Strategy",

            "Video Production",
            "Influencer Marketing",
            "Market Research & Analysis",
            "Other",
        ],
    },
    {
        type: "Digital Marketing Agency",
        subtype: "Business Promotion Strategies",
        icon: "svg/Digital-marketing-Agency.svg",
        services: [
            "Search Engine Optimization (SEO)",
            "Pay-Per-Click (PPC) Advertising",
            "Social Media Marketing",
            "Content Marketing",
            "Email Marketing",
            "Influencer Marketing",
            "Video Marketing",
            "Conversion Rate Optimization (CRO)",
            "Web Design & Development",
            "Branding & Strategy",
            "Analytics & Reporting",
            "Voice Search Optimization",
            "Affiliate Marketing",
            "Reputation Management",
            "Chatbot & AI Integration",
            "Other",
        ],
    },
    {
        type: "Personal Trainer",
        subtype: "Individual Fitness Coaching",
        icon: "images/other.png",
        services: [
            "Personalized Workout Plans",
            "One-on-One Training",
            "Nutrition Guidance",
            "Fitness Assessments",
            "Virtual Training Sessions",
            "Group Training",
            "Weight Loss Programs",
            "Strength Training Plans",
            "Other",
        ],
    },
    {
        type: "Architect",
        subtype: "Building Design Expert",
        icon: "svg/Architect-icon.svg",
        services: [
            "Residential Building Design",
            "Commercial Building Plans",
            "Renovation Planning",
            "Permit Drawings",
            "Site Planning",
            "Project Management",
            "3D Modeling & Rendering",
            "Interior Layout Planning",
            "Sustainable/Green Building Design",
            "Landscape Architecture",
            "Other",
        ],
    },
    {
        type: "Interior Designer",
        subtype: "Indoor Space Beautifier",
        icon: "images/other.png",
        services: [
            "Space Planning",
            "Furniture Selection",
            "Color Consultation",
            "Lighting Design",
            "Home Makeovers",
            "Modular Kitchen Designing",
            "Office Interior Design",
            "Smart Home Designing",
            "Renovation Consulting",
            "Other",
        ],
    },
    {
        type: "Construction Services",
        subtype: "Building Construction & Repair",
        icon: "svg/Construction Services.svg",
        services: [
            "New Building Construction",
            "Home Renovations",
            "Project Supervision",
            "Structural Repairs",
            "Road & Bridge Construction",
            "Demolition Services",
            "Waterproofing Solutions",
            "Interior Fit-outs",
            "Other",
        ],
    },
    {
        type: "Cleaning and Janitorial Services",
        subtype: "Building Construction & Repair",
        icon: "images/other.png",
        services: [
            "Office Cleaning",
            "Deep Carpet Cleaning",
            "Window Washing",
            "Floor Polishing",
            "Regular Maintenance",
            "Disinfection Services",
            "Industrial Cleaning",
            "Pest Control Services",
            "Carpet Shampooing",
            "Other",
        ],
    },
    {
        type: "Transport Company",
        subtype: "Freight Transportation Services",
        icon: "images/other.png",
        services: [
            "Freight Shipping",
            "Passenger Transport",
            "Courier Services",
            "Vehicle Rentals",
            "Logistics Management",
            "Warehousing",
            "Cold Chain Logistics",
            "Goods Packaging Services",
            "Express Cargo Delivery",
            "Other",
        ],
    },
    {
        type: "Landscaping Company",
        subtype: "Outdoor Space Beautification",
        icon: "images/other.png",
        services: [
            "Lawn Mowing & Maintenance",
            "Garden Design",
            "Tree Pruning & Removal",
            "Irrigation Installation",
            "Other",
        ],
    },
    {
        type: "Insurance Agency",
        subtype: "Risk Protection Provider",
        icon: "svg/Insurance Agency.svg",
        services: [
            "Life Insurance",
            "Health Insurance",
            "Car Insurance",
            "Home Insurance",
            "Business Insurance",
            "Travel Insurance",
            "Pet Insurance",
            "Business Liability Insurance",
            "Cyber Insurance",
            "Other",
        ],
    },
    {
        type: "Financial Services",
        subtype: "Wealth Management Advice",
        icon: "images/other.png",
        services: [
            "Investment Planning",
            "Tax Preparation",
            "Retirement Planning",
            "Wealth Management",
            "Loan Consulting",
            "Credit Score Improvement",
            "Portfolio Management",
            "Business Loan Assistance",
            "Debt Consolidation",
            "Other",
        ],
    },
    {
        type: "Accounting Services",
        subtype: "Financial Record Management",
        icon: "svg/Accounting Services.svg",
        services: [
            "Bookkeeping",
            "Tax Filing",
            "Payroll Services",
            "Financial Auditing",
            "Business Financial Reports",
            "GST Services",
            "Forensic Accounting",
            "Startup Financial Consulting",
            "Cloud Accounting Setup",

            "Other",
        ],
    },
    {
        type: "Boat Repair & Maintenance",
        subtype: "Watercraft Upkeep & Repair",
        icon: "images/other.png",
        services: [
            "Hull Repair",
            "Engine Maintenance",
            "Electrical System Repairs",
            "Boat Cleaning",
            "Winterizing Services",
            "Other",
        ],
    },
    {
        type: "Dentist",
        subtype: "Dental Care Provider",
        icon: "images/other.png",
        services: [
            "Teeth",
            "Cleaning",
            "Teeth Whitening",
            "Braces & Aligners",
            "Root Canal",
            "Tooth Extraction",
            "Cosmetic Dentistry",
            "Dental Implants",
            "Orthodontics",
            "Pediatric Dentistry",
            "Other",
        ],
    },
    {
        type: "Property Rental & Leasing Service",
        subtype: "Property Rental Management",
        icon: "svg/Property Rental & Leasing Service.svg",
        services: [
            "Tenant Screening",
            "Lease Agreement Preparation",
            "Rent Collection",
            "Property Maintenance Coordination",
            "Short-Term Rentals",
            "Vacation Rentals",
            "Co-Working Spaces",
            "Property Advertising",
            "Other",
        ],
    },
    {
        type: "Old Age Home",
        subtype: "Senior Living Facility",
        icon: "svg/Old Age Home.svg",
        services: [
            "Assisted Living",
            "Meal Services",
            "Housekeeping & Laundry",
            "Recreational Activities",
            "Physiotherapy",
            "Emergency Support",
            "Medical Care & Nursing",
            "Counseling & Emotional Support",
            "Other",
        ],
    },
    {
        type: "Travel Agency",
        subtype: "Trip Planning & Booking",
        icon: "svg/Travel Agency.svg",
        services: [
            "Flight Booking",
            "Hotel Reservations",
            "Holiday Packages",
            "Visa Assistance",
            "Travel Insurance",
            "Customized Itineraries",
            "Cruise Bookings",
            "Local Tours & Sightseeing",
            "Car Rentals",
            "Other",
        ],
    },
    {
        type: "Ticket Booking",
        subtype: "Travel Ticket Provider",
        icon: "svg/Ticket Booking.svg",
        services: [
            "Flight Tickets",
            "Train Tickets",
            "Bus Tickets",
            "Movie Tickets",
            "Event Tickets",
            "Amusement Park Tickets",
            "Concert & Show Tickets",
            "Sports Tickets",
            "Other",
        ],
    },
    {
        type: "Financial Planners",
        subtype: "Wealth Management Advice",
        icon: "svg/Financial Planners.svg",
        services: [
            "Retirement Planning",
            "Investment Portfolio Management",
            "Tax Planning",
            "Budgeting & Expense Management",
            "Estate Planning",
            "Insurance Planning",
            "Education Planning",
            "Debt Management",
            "Other",
        ],
    },
    {
        type: "Beauty Parlour",
        subtype: "Cosmetic Beauty Services",
        icon: "svg/Beauty Parlour.svg",
        services: [
            "Hair Cutting & Styling",
            "Facials & Cleanups",
            "Manicure & Pedicure",
            "Bridal Makeup",
            "Hair Coloring & Highlights",
            "Waxing & Threading",
            "Skin Treatments",
            "Makeup for Events",
            "Spa & Massage Services",
            "Other",
        ],
    },
    {
        type: "Nail Salon",
        subtype: "Manicure/Pedicure Services",
        icon: "svg/Nail Saloon.svg",
        services: [
            "Manicure",
            "Pedicure",
            "Nail Art",
            "Gel Nails",
            "Acrylic Nails",
            "Nail Extensions",
            "Cuticle Care",
            "Nail Repair & Removal",
            "Hand & Foot Spa",
            "Other",
        ],
    },
    {
        type: "Barber Studio/Shop",
        subtype: "Men's Hair Grooming",
        icon: "svg/Barber.svg",
        services: [
            "Haircut",
            "Beard Trimming & Styling",
            "Shaving & Grooming",
            "Hair Coloring",
            "Head Massage",
            "Facial for Men",
            "Scalp Treatment",
            "Hair Wash & Styling",
            "Kids Haircut",
            "Other",
        ],
    },
    {
        type: "Hair Stylist",
        subtype: "Professional Hair Care",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Hair Cutting & Trimming",
            "Hair Styling",
            "Blow Dry & Ironing",
            "Hair Coloring & Highlights",
            "Hair Spa",
            "Keratin & Smoothening Treatments",
            "Hair Extensions",
            "Scalp Treatments",
            "Bridal & Occasion Hairstyles",
            "Other",
        ],
    },
    {
        type: "Bakery",
        subtype: "Baked Goods Producer",
        icon: "svg/Bakery.svg",
        services: [
            "Custom Cakes",
            "Birthday & Wedding Cakes",
            "Pastries & Cupcakes",
            "Cookies & Biscuits",
            "Bread & Buns",
            "Chocolates & Desserts",
            "Eggless & Sugar-Free Items",
            "Bulk & Party Orders",
            "Online Ordering & Delivery",
            "Other",
        ],
    },
    {
        type: "Cleaning Janitorial Service",
        subtype: "Professional Cleaning Solutions",
        icon: "svg/Cleaning Janitorial Service.svg",
        services: [
            "Residential Cleaning",
            "Commercial Office Cleaning",
            "Deep Cleaning Services",
            "Move-In/Move-Out Cleaning",
            "Carpet & Upholstery Cleaning",
            "Window Cleaning",
            "Disinfection & Sanitization",
            "Post-Construction Cleaning",
            "Restroom Cleaning & Maintenance",
            "Other",
        ],
    },
    {
        type: "Tour Guides",
        subtype: "Travel Experience Curator",
        icon: "svg/Tour-Guides.svg",
        services: [
            "Guided City Tours",
            "Historical Site Tours",
            "Adventure and Nature Tours",
            "Cultural & Art Tours",
            "Food & Culinary Tours",
            "Wildlife & Eco Tours",
            "Photography Tours",
            "Private Custom Tours",
            "Other",
        ],
    },
    {
        type: "Deli Shop",
        subtype: "Fresh Meats & Gourmet Foods",
        icon: "svg/Deli Shop.svg",
        services: [
            "Fresh Cut Meats",
            "Artisanal Cheeses",
            "Gourmet Sandwiches",
            "Prepared Salads & Sides",
            "Imported & Local Delicacies",
            "Cured Meats & Cold Cuts",
            "Ready-to-Eat Meals",
            "Bakery Items",
            "Specialty Beverages",
            "Custom Deli Platters",
            "Other",
        ],
    },
    {
        type: "Dry Cleaners",
        subtype: "Garment Cleaning & Care",
        icon: "svg/Dry Cleaner.svg",
        services: [
            "Regular Garment Dry Cleaning",
            "Suit & Blazer Cleaning",
            "Wedding Dress Cleaning",
            "Delicate Fabric Care (Silk, Wool, etc.)",
            "Stain Removal Services",
            "Curtains & Drapes Cleaning",
            "Carpet & Rug Cleaning",
            "Blankets & Quilts Cleaning",
            "Steam Ironing & Pressing",
            "Leather & Suede Cleaning",
            "Pickup & Delivery Service",
            "Express / Same-Day Cleaning",
            "Eco-Friendly Cleaning",
            "Other",
        ],
    },
    {
        type: "Car Repair & Garage",
        subtype: "Quality Repairs, Every Time",
        icon: "svg/Car Repair & Garage.svg",
        services: [
            "General Car Servicing",
            "Engine Diagnostics & Repair",
            "Brake Inspection & Repair",
            "Oil Change & Filter Replacement",
            "Battery Check & Replacement",
            "AC Repair & Gas Refill",
            "Suspension & Steering Repair",
            "Wheel Alignment & Balancing",
            "Tire Rotation & Replacement",
            "Clutch & Transmission Services",
            "Car Washing & Detailing",
            "Bodywork & Painting",
            "Accidental Repair Services",
            "Windshield & Glass Repair",
            "Pickup & Drop-off Service",
            "24/7 Emergency Roadside Assistance",
            "Pre-Purchase Car Inspection",
            "Insurance Claim Assistance",
            "Other",
        ],
    },
    {
        type: "Boat Repair",
        subtype: "Marine Care & Repair Experts",
        icon: "svg/Boat Repair & Maintenance.svg",
        services: [
            "Engine Diagnostics & Repairs",
            "Hull Cleaning & Polishing",
            "Fiberglass & Gelcoat Repair",
            "Electrical System Inspection",
            "Boat Painting & Detailing",
            "Propeller & Shaft Repair",
            "Bilge Pump Service",
            "Navigation System Maintenance",
            "Fuel System Inspection",
            "Winterizing & De-winterizing",
            "Trailer Repair & Maintenance",
            "Custom Modifications",
            "On-Site Repair Services",
            "Other",
        ],
    },
    {
        type: "Car & Bus Services",
        subtype: "Quality Repairs, Every Time",
        icon: "svg/Car Repair & Garage.svg",
        services: [
            "Engine Diagnostics & Repairs",
            "Brake Inspection & Replacement",
            "Oil Change & Filter Replacement",
            "Battery Check & Replacement",
            "Transmission Service & Repair",
            "Suspension & Steering Services",
            "AC & Heating System Repair",
            "Electrical System Troubleshooting",
            "Tire Rotation & Wheel Alignment",
            "Exhaust System Repair",
            "Fuel Injection Cleaning",
            "Coolant System Flush & Repair",
            "Bus Fleet Maintenance",
            "Roadside Assistance & Towing",
            "Preventive Maintenance Plans",
            "Other",
        ],
    },
    {
        type: "Taxi, Cab & Limo Booking",
        subtype: "Reliable Rides, Anytime, Anywhere",
        icon: "svg/Taxi.svg",
        services: [
            "Local Taxi Booking",
            "Outstation Cab Services",
            "Airport Pickup & Drop",
            "Corporate Cab Services",
            "Hourly Limo Rentals",
            "Luxury Car Chauffeur",
            "Event Transportation",
            "24/7 Cab Availability",
            "One-Way & Round Trips",
            "Shared Ride Services",
            "Other",
        ],
    },
    {
        type: "Movers and Packers",
        subtype: "Safe & Hassle-Free Relocation Services",
        icon: "svg/Movers and Packers.svg",
        services: [
            "Home Shifting",
            "Office Relocation",
            "Local & Domestic Moving",
            "Packing & Unpacking Services",
            "Loading & Unloading",
            "Furniture Dismantling & Assembly",
            "Vehicle Transportation",
            "Storage & Warehousing",
            "International Relocation",
            "Fragile Item Handling",
            "Other",
        ],
    },
    {
        type: "Trucking Company",
        subtype: "Efficient Freight & Logistics Solutions",
        icon: "svg/Trucking Company.svg",
        services: [
            "Long-Haul Trucking",
            "Local & Regional Deliveries",
            "Refrigerated Trucking",
            "Flatbed Trucking",
            "Heavy Equipment Transportation",
            "Interstate Cargo Transport",
            "Logistics & Freight Management",
            "24/7 Shipment Tracking",
            "Other",
        ],
    },
    {
        type: "Spa & Wellness Center",
        subtype: "Relaxation & Health Services",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Swedish Massage",
            "Deep Tissue Massage",
            "Hot Stone Massage",
            "Aromatherapy Massage",
            "Couples Massage",
            "Classic/Custom Facial",
            "Deep-Cleansing (Acne) Facial",
            "Body Scrub / Exfoliation",
            "Detox or Hydrating Body Wrap",
            "Waxing (Face/Body)",
            "Other",
        ],
    },
    {
        type: "Print Shop",
        subtype: "Your Printing Solutions Partner",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Business Cards",
            "Flyers & Brochures",
            "Posters & Banners",
            "Custom T-Shirts",
            "Photo Printing",
            "Booklets & Catalogs",
            "Invitations & Greeting Cards",
            "Stickers & Labels",
            "Large Format Printing",
            "Other",
        ],
    },
    {
        type: "School",
        subtype: "Education for a Brighter Future",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Primary Education",
            "Secondary Education",
            "STEM Programs",
            "Arts & Humanities",
            "Sports & Extracurriculars",
            "Special Education",
            "Language Courses",
            "Online Learning",
            "After-School Programs",
            "Other",
        ],
    },
    {
        type: "Colleges & Universities",
        subtype: "Higher Learning Institution",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Undergraduate Programs",
            "Graduate Programs",
            "Professional Degrees",
            "Online Courses",
            "Research Opportunities",
            "Internships & Co-ops",
            "Study Abroad Programs",
            "Student Support Services",
            "Extracurricular Activities",
            "Other",
        ],
    },
    {
        type: "Training Center",
        subtype: "Skill Development Hub",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Technical Skills Training",
            "Soft Skills Development",
            "Certification Programs",
            "Workshops & Seminars",
            "Online Learning Modules",
            "Corporate Training Solutions",
            "Career Counseling",
            "Internship Placement",
            "Other",
        ],
    },
    {
        type: "Educational Institute",
        subtype: "Knowledge Empowerment Center",
        icon: "svg/Hair Stylist.svg",
        services: [
            "Academic Programs",
            "Vocational Training",
            "Research & Development",
            "Community Education",
            "Online Learning Platforms",
            "Student Support Services",
            "Extracurricular Activities",
            "Other",
        ],
    },
    {
        type: "Plumber",
        subtype: "Water System Specialist",
        icon: "svg/Plumber.svg",
    services: [
        "Residential Plumbing Services",
        "Commercial Plumbing Services",
        "Industrial Plumbing Solutions",
        "Pipe Installation & Maintenance",
        "Drainage & Sewer Cleaning",
        "Leak Detection & Repair",
        "Bathroom & Kitchen Fittings",
        "Water Heater Installation & Repair",
        "Water Tank Cleaning & Maintenance",
        "Emergency Plumbing Services",
        "Plumber"
    ],
    },

];